export default "/images/img-2.jpg?9ad853b2a11d405bb46e503b9737a953";